import { jsx as i } from "react/jsx-runtime";
import { TextCapsuleContainer as l } from "./style.js";
import { TextCapsuleContainerSkeleton as f } from "./style.js";
function s({
  content: t,
  isSelected: r,
  className: o,
  size: a,
  onClick: e
}) {
  return /* @__PURE__ */ i(
    l,
    {
      className: o,
      "aria-selected": r,
      onClick: () => {
        e && e(t);
      },
      size: a,
      role: e ? "button" : "div",
      children: t
    }
  );
}
export {
  s as TextCapsule,
  f as TextCapsuleSkeleton
};
